import React from 'react'
import workshopbanner from '../images/workshopbanner.png'

export default function Workshopbanner() {
  return (
    <div className='container mx-auto mb-7 mt-5 '>
        <img src={workshopbanner} alt='workshop onlinepaathshala' className='h-[200px] w-full'></img>
    </div>
  )
}
